import { CachePolicy, Query } from 'contentstack';
import { unstable_cache } from 'next/cache';

import {
    ContentStack,
    ContentStackLivePreview,
} from '@nxt-costco-com/forge-digital-components';
import type { ContentTypeProps } from '@nxt-costco-com/forge-digital-components';

const _findOneWithArrayValues = async function _findOneWithArrayValues<T>(
    contentType: ContentTypeProps,
    key: string,
    value: string[],
    enableLivePreview: boolean,
): Promise<T> {
    let stackClient = ContentStack;

    if (enableLivePreview) {
        stackClient = ContentStackLivePreview;
        stackClient.setCachePolicy(CachePolicy.IGNORE_CACHE);
    }

    const andQuery = value.map(value => {
        // @ts-expect-error CS Typing does not include this valid syntax
        return { [key]: value.toLowerCase() } as Query;
    });
    try {
        return (await stackClient.stack
            .ContentType(contentType)
            .Query()
            .and(...andQuery)
            .toJSON()
            .findOne()) as T;
    } catch (err) {
        throw new Error(
            `An error occurred in _findOneWithArrayValues (${contentType}, ${key}, ${JSON.stringify(andQuery)}): ${JSON.stringify(err)}`,
        );
    }
};

const cached_findOneWithArrayValues = unstable_cache(
    _findOneWithArrayValues,
    ['search_findOneWithArrayValues'],
    { revalidate: 1800 },
);

export const findOneWithArrayValues = async function findOneWithArrayValues<T>(
    contentType: ContentTypeProps,
    key: string,
    value: string[],
    enableLivePreview: boolean,
): Promise<T> {
    const fn =
        typeof window === 'undefined'
            ? cached_findOneWithArrayValues
            : _findOneWithArrayValues;

    return fn(contentType, key, value, enableLivePreview);
};
